import { Lightning as lng, Log, Registry, Router, Utils } from '@lightningjs/sdk';
import { Theme } from '../config/theme';
import { TokenApi } from '../api/bootstrap/TokenApi';
import { Login } from '../Business/Login';
import { StaticPageUrls } from '../api/analytics/ClientEvents';
import { Backend } from '../api/Backend';

export class SplashPage extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: Theme.Colors.Transparent,
      rect: true,
      Background: {
        x: 0,
        y: 0,
        w: w => w,
        h: h => h,
        src: Utils.asset('images/background.png'),
      },
      SplashText: {
        x: 0,
        y: 0,
        w: w => w,
        h: h => h,
        src: Utils.asset('images/splash-screen.png'),
      },
    };
  }

  _onChanged() {
    Registry.setTimeout(() => {
      this.setup();
    }, 250);
  }

  async setup() {
    const backend = Backend.instance;

    try {
      await backend.initialize();
    } catch (e) {
      Log.error('Initialization of backend failed', e);
      backend.rootPage = 'fatalError';
      Router.navigate('fatalError', { backend: backend, error: e });
      Router.resume();
      return;
    }
    try {
      const token = TokenApi.load();
      backend.logService.trackPageView(StaticPageUrls.splash);
      const allowUnauthenticatedUse = backend.globalSettings.boolValue('allowUnauthenticatedUse');
      Log.info(token, allowUnauthenticatedUse);
      await backend.playerController.playerService.bootstrap();
      if (!token && !allowUnauthenticatedUse) {
        backend.rootPage = 'login';
        Router.resume();
        return;
      }
      if (token.access && token.access.isValid()) {
        Log.info('Access token still valid');
        backend.token = token;
        await Login.initSession(backend);
        await this._setRootPage(backend);
        return;
      }
      if (token.refresh && token.refresh.isValid()) {
        const refreshedToken = await TokenApi.refresh(backend, token.refresh.token);
        if (refreshedToken.access.token && refreshedToken.access.isValid()) {
          backend.token = refreshedToken;
          TokenApi.save(refreshedToken);
          await Login.initSession(backend);
          await this._setRootPage(backend);
          return;
        }
      }
      Log.info('All tokens expired, showing login');
      backend.rootPage = 'login';
      Router.resume();
    } catch (e) {
      Log.error('Token fetching failed', e);
      backend.rootPage = 'login';
      Router.resume();
    }
  }

  async _setRootPage(backend) {
    const autoCloseMenu = backend.globalSettings.numberValue('autoCloseMenuDelayV2') ?? 0;
    if (autoCloseMenu < 0) {
      backend.rootPage = 'main';
    } else if (autoCloseMenu === 0) {
      backend.rootPage = 'play';
      try {
        await backend.playerController.fallbackToLinearStream();
      } catch (err) {
        backend.rootPage = 'main';
        Log.warn('Failed to start stream, continuing with startup');
      }
    } else {
      backend.rootPage = 'main';
      this.fireAncestors('$setDelayedNavigation', 'play', autoCloseMenu);
    }
    Router.resume();
  }
}
